"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _runtime = require("../runtime");
var _default = exports.default = (0, _runtime.IconWrapper)('warn_normal', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("style", ['.kd-stroke-width-icon-regular{stroke-width:var(--kd-stroke-width-icon-regular, 1px); }.kd-color-icon-white{fill:#FFFFFF; fill:var(--kd-color-icon-white, #FFFFFF); stroke:#FFFFFF; stroke:var(--kd-color-icon-white, #FFFFFF); }.kd-color-icon-warning{fill:#E2651A; fill:var(--kd-color-icon-warning, #E2651A); stroke:#E2651A; stroke:var(--kd-color-icon-warning, #E2651A); }']), h("g", {
    "class": "kd-color-icon-warning kd-stroke-width-icon-regular"
  }, [h("path", {
    "attrs": {
      "d": "M6.2521 2.02314C7.01671 0.663839 8.97379 0.663837 9.7384 2.02313L15.7422 12.0193C16.4921 13.3525 15.5145 14.9999 13.9848 14.9999H2.00486C0.475212 14.9999 -0.488216 13.3526 0.261714 12.0193L6.2521 2.02314Z",
      "stroke": "none"
    }
  })]), h("g", {
    "class": "kd-color-icon-white kd-stroke-width-icon-regular"
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M8 4.99976C8.55228 4.99976 9 5.44747 9 5.99976V8.99976C9 9.55204 8.55228 9.99976 8 9.99976C7.44772 9.99976 7 9.55204 7 8.99976V5.99976C7 5.44747 7.44772 4.99976 8 4.99976ZM7 11.9998C7 11.4475 7.44772 10.9998 8 10.9998C8.55228 10.9998 9 11.4475 9 11.9998C9 12.552 8.55228 12.9998 8 12.9998C7.44772 12.9998 7 12.552 7 11.9998Z",
      "stroke": "none"
    }
  })])]);
});